import React, { useState, useEffect } from 'react';

const withPageZoom = (WrappedComponent) => {
  const PageZoomContainer = (props) => {
    const [isPageZoomed, setIsPageZoomed] = useState(false);

    useEffect(() => {
      const { visualViewport } = window;
      if (!visualViewport) return undefined;

      const handleResize = () => setIsPageZoomed(visualViewport.scale > 1);

      handleResize();
      visualViewport.addEventListener('resize', handleResize);

      return () => visualViewport.removeEventListener('resize', handleResize);
    }, []);

    return <WrappedComponent {...props} isPageZoomed={isPageZoomed} />;
  };

  return PageZoomContainer;
};

export default withPageZoom;
